import type { StatusMeta } from '../../services/workQueue';

// Version normalised like shared-ui's isV2PatientVersion; anything not V2 reads the default.
export function metaFor(
    status: StatusMeta | undefined,
    version: string | null
): StatusMeta | undefined {
    const isV2 = (version ?? '').trim().toUpperCase() === 'V2';
    const override = isV2 ? status?.byVersion?.V2 : undefined;
    return status && override ? { ...status, ...override } : status;
}
